export default "__VITE_ASSET__CLXfhzfj__"